module.exports = __webpack_public_path__ + "img/dk.c89ee484.svg";